import * as yup from 'yup';

import { endpointUrlValidation } from './endpointUrl';

export const editWebhookFormSchema = yup
  .object({
    endpointUrl: endpointUrlValidation().required(),
    businessUnitUuid: yup.string().label('Business unit').required(),
    xAuthUuid: yup.string().label('X-Auth-UUID').required(),
    status: yup.boolean().required()
  })
  .required();

export type EditWebhookFormValues = yup.InferType<typeof editWebhookFormSchema>;
